import { defineMessages } from 'react-intl-next';
export var colorPickerButtonMessages = defineMessages({
  colorPickerMenuLabel: {
    id: 'fabric.editor.colorPicker.menuLabel',
    defaultMessage: 'Color picker menu',
    description: 'The label for the color picker menu popup window'
  }
});